// Compare the screened name with the visible card title, not a scorer-selected
// alias. Display refinement only: never use this to score, rank or retrieve candidates.
export function nameMatchDisplayLabel(strength, screenedName, comparedName) {
  const tokens = value => (String(value || '').normalize('NFC').toLowerCase().match(/[\p{L}\p{M}\p{N}]+/gu) || []).sort();
  if (strength === 'strong') {
    const screened = tokens(screenedName), compared = tokens(comparedName);
    if (screened.length && screened.length === compared.length && screened.every((word, index) => word === compared[index])) return 'Exact match';
  }
  return strength ? `${strength[0].toUpperCase() + strength.slice(1)} match` : 'Unavailable';
}
